import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    Toolbar,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Device } from "types/Device";
import { DiagnosticsMetrics } from "features/diagnostics/DiagnosticsMetrics";

export interface DeviceDiagnosticsDialogProps {
    closeDialog: () => void;
    device: Device;
    diagnosticsCorrelationId: string;
}

export function DeviceDiagnosticsDialog(props: DeviceDiagnosticsDialogProps) {
    return (
        <Dialog
            open={true}
            slotProps={{
                paper: {
                    sx: {
                        width: "60%",
                        maxWidth: "none",
                    },
                },
            }}
        >
            <AppBar sx={{ position: "relative" }}>
                <Toolbar>
                    <Typography
                        sx={{ ml: 2, flex: 1 }}
                        variant="h6"
                        component="div"
                    >
                        {props.device.name} Diagnostics
                    </Typography>
                    <Button
                        autoFocus
                        color="inherit"
                        onClick={props.closeDialog}
                    >
                        <CloseIcon />
                    </Button>
                </Toolbar>
            </AppBar>
            <DialogContent>
                <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    sx={{ mb: 0.5 }}
                >
                    Diagnostics Correlation ID
                </Typography>
                <Typography
                    variant="body2"
                    sx={{ wordBreak: "break-all", mb: 2 }}
                >
                    {props.diagnosticsCorrelationId}
                </Typography>
                <DiagnosticsMetrics
                    diagnosticsCorrelationId={props.diagnosticsCorrelationId}
                    showStartupFlow={true}
                ></DiagnosticsMetrics>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.closeDialog}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}
